import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { LoginType } from '@api/gateway/BasicData-default'

interface State {
  showLogin: boolean
  showRegister: boolean
  showBinding: boolean
  isOnlyAdmin: boolean
}

@Module({ namespaced: true, dynamic: true, store, name: 'LoginDialogModule' })
class LoginDialogModule extends VuexModule implements State {
  showBinding = false
  showLogin = false
  showRegister = false
  // 只有管理员登录(集体报名时弹窗)
  isOnlyAdmin = false
  accountLoginType = LoginType.IDENTITYCARD
  // 缓存登录方式 现在有两个登录的入口（弹窗和登录卡片） 会引起混乱
  cacheAccountLoginType = LoginType.IDENTITYCARD
  /**
   * 设置登录对话框显示状态
   * @param ctx
   * @param isShow
   */
  @Action
  setShowLoginDialog(isShow: boolean) {
    this.SET_SHOW_LOGINDIALOG(isShow)
    if (!isShow) {
      // 隐藏时，自动复位
      this.SET_LOGIN_TYPE(false)
    }
  }

  /**
   * 设置注册对话框显示状态
   * @param ctx
   * @param isShow
   */
  @Action
  setShowRegisterDialog(isShow: boolean) {
    this.SET_SHOW_REGISTERDIALOG(isShow)
  }

  @Action
  setShowBindingWeixinDialog(isShow: boolean) {
    this.SET_SHOW_BINDING_WEIXIN(isShow)
  }

  @Action
  setLoginType(isOnlyAdmin: boolean) {
    this.SET_LOGIN_TYPE(isOnlyAdmin)
  }

  @Action
  setAccountLoginType(loginType: LoginType) {
    this.SET_ACCOUNT_LOGIN_TYPE(loginType)
  }

  @Mutation
  SET_ACCOUNT_LOGIN_TYPE(loginType: LoginType) {
    this.accountLoginType = loginType
  }

  @Mutation
  SET_SHOW_LOGINDIALOG(isShow: boolean) {
    this.showLogin = isShow
    // 打开弹窗如果是尽显管理员登录的必定是手机 如果是普通方式  则是身份证 在调用的时候设置有没有仅限管理员要还在弹窗的后面
    if (isShow) {
      this.cacheAccountLoginType = this.accountLoginType
      this.accountLoginType = LoginType.IDENTITYCARD
    } else {
      this.accountLoginType = this.cacheAccountLoginType
    }
    console.log('状态层', this.accountLoginType, this.cacheAccountLoginType)
  }

  @Mutation
  SET_SHOW_REGISTERDIALOG(isShow: boolean) {
    this.showRegister = isShow
  }

  @Mutation
  SET_SHOW_BINDING_WEIXIN(isShow: boolean) {
    this.showBinding = isShow
  }

  @Mutation
  SET_LOGIN_TYPE(isOnlyAdmin: boolean) {
    this.isOnlyAdmin = isOnlyAdmin
    if (isOnlyAdmin) {
      this.accountLoginType = LoginType.PHONE
    }
    console.log('最终的状态层', this.accountLoginType, this.cacheAccountLoginType)
  }

  get isShowLogin() {
    return this.showLogin
  }

  get isShowRegister() {
    return this.showRegister
  }
}

export default getModule(LoginDialogModule)
